import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { ReauthorizationEcshopRequestModel, ReauthorizationEcshopResponseModel } from "@/features/accounts/ecshop/services/reauthorization-model";

export class ReauthorizationEcshopApi {
  /**
   * その他連携サービスサイト認可画面要求(再認可)API
   */
  public reauthorize = async (
    param: ReauthorizationEcshopRequestModel
  ): Promise<ReauthorizationEcshopResponseModel> => {
    const path = `/api/ecshopaccounts/authorization`;
    const res = await ApiClient.instance.get<ReauthorizationEcshopResponseModel>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
